<ws-modal-wrapper
    headerLabel="Select Payment Approver"
    acceptLabel="Select"
    cancelLabel="Cancel"
    acceptClass="btn-primary"
    cancelClass="btn-primary"
    [disableSave]="loading || !isSelectionValid"
    [disableCancel]="loading"
    [loading]="loading"
    (save)="save()"
    (cancel)="cancel()">
    <div class="d-flex align-items-center mb-3">
        <label class="mb-0">
            <input
                type="checkbox"
                [(ngModel)]="includeAllCompanyContacts"
                (change)="onShowAllCompanyContactsChanged()"
                [disabled]="loading" />
            <span class="ms-1">Show all company contacts</span>
        </label>
    </div>

    @if (!loading && autoExpandedToAllContacts && candidates.length > 0) {
        <div class="alert alert-info py-1 px-2 mb-2" style="font-size: 0.875rem;">
            No designated payment approvers were found for the selected payments.
            Showing all company contacts instead.
        </div>
    }

    @if (!loading && candidates.length === 0 && !includeAllCompanyContacts) {
        <div class="text-muted">No eligible payment approvers were found.</div>
    }

    @if (!loading && candidates.length === 0 && includeAllCompanyContacts) {
        <div class="text-muted">No company contacts with an active user account were found.</div>
    }

    @if (!loading) {
        <div class="input-group scrollable-typeahead">
            <input
                type="text"
                class="form-control"
                placeholder="Search approver..."
                [(ngModel)]="selectedDisplayName"
                [wsTypeahead]="candidates"
                typeaheadOptionField="displayName"
                [typeaheadMinLength]="0"
                [typeaheadScrollable]="true"
                [typeaheadOptionsLimit]="100"
                container="body"
                (typeaheadOnSelect)="onApproverSelected($event)"
                [disabled]="loading || candidates.length === 0" />
        </div>
    }
</ws-modal-wrapper>
